import { render, staticRenderFns } from "./VxUpload.vue?vue&type=template&id=4f18f662&"
import script from "./VxUpload.vue?vue&type=script&lang=js&"
export * from "./VxUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports